import script from "./ServiceProviderDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceProviderDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ServiceProviderDrawer.vue?vue&type=style&index=0&id=b3a4c46e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a4c46e"]])

export default __exports__